import React from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  fullWidth = false
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`
        relative group overflow-hidden rounded-lg bg-brand px-8 py-4 
        font-display text-2xl tracking-wider text-white shadow-[0_0_20px_rgba(234,88,12,0.4)]
        transition-all hover:bg-brand-light hover:shadow-[0_0_30px_rgba(234,88,12,0.6)]
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-203">
      <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-204" />
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-205">
        <Flame className="w-6 h-6 fill-current" data-id="element-206" />
        {children}
      </span>
    </motion.button>;
}